import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface TrendPoint {
  date: string;
  precision: number;
  quality_score: number;
}

interface Props {
  data: TrendPoint[];
}

export const PrecisionChart: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4">Evolution (30 jours)</h3>
        <div className="flex items-center justify-center h-[250px] text-gray-500">
          Aucune donnee disponible
        </div>
      </div>
    );
  }

  const formattedData = data.map(d => ({
    ...d,
    date: new Date(d.date).toLocaleDateString('fr-CA', { month: 'short', day: 'numeric' }),
    precision: d.precision != null ? (d.precision * 100).toFixed(1) : '0',
    quality_score: d.quality_score != null ? d.quality_score.toFixed(0) : '0',
  }));

  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Evolution (30 jours)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" fontSize={12} />
          <YAxis domain={[0, 100]} fontSize={12} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="precision"
            stroke="#3b82f6"
            name="Précision (%)"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="quality_score"
            stroke="#10b981"
            name="Score qualité"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
